import { ArrowUpRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { CONTACT, NAV_LINKS } from "@/data/site";
import { scrollTo } from "./Reveal";

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (href) => (e) => {
    e.preventDefault();
    if (!href.startsWith("#")) return navigate(href);
    if (pathname !== "/") return navigate(`/${href}`);
    scrollTo(href);
  };
  return (
  <footer className="relative border-t border-gold/15 bg-ink" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12 pt-20 pb-10">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <div className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light leading-none tracking-tight text-ivory">
            Bossard
            <span className="block text-gold italic">Investment Group</span>
          </div>
          <p className="mt-8 text-ivory/50 max-w-md text-sm leading-relaxed">
            {CONTACT.legalName} — a family-owned real estate investment firm serving Washington D.C., Maryland and Virginia.
            Operating as{" "}
            <a href={CONTACT.dbaUrl} target="_blank" rel="noreferrer" className="text-gold link-underline" data-testid="footer-dba-link">
              {CONTACT.dbaName}
            </a>
            .
          </p>
        </div>

        <div className="lg:col-span-3 lg:col-start-8">
          <div className="eyebrow mb-6">Navigate</div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href.startsWith("#") ? `/${l.href}` : l.href} onClick={go(l.href)} className="text-sm text-ivory/70 hover:text-gold transition-colors" data-testid={`footer-link-${l.href.replace(/^[#/]/, "")}`}>
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="eyebrow mb-6">Reach us</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`mailto:${CONTACT.email}`} className="text-ivory/70 hover:text-gold transition-colors break-all" data-testid="footer-email">{CONTACT.email}</a>
            </li>
            <li>
              <a href={CONTACT.phoneHref} className="text-ivory/70 hover:text-gold transition-colors" data-testid="footer-phone">{CONTACT.phone}</a>
            </li>
            <li>
              <a href={CONTACT.calendly} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-gold" data-testid="footer-calendly">
                Schedule a call <ArrowUpRight size={13} />
              </a>
            </li>
            <li className="text-ivory/50">{CONTACT.location}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-gold/10 grid lg:grid-cols-12 gap-6 text-[11px] leading-relaxed text-ivory/35">
        <p className="lg:col-span-8" data-testid="footer-disclaimer">
          Investment opportunities, financing approvals, projected returns, tax treatment and refinance outcomes are not
          guaranteed. Real estate investing involves risk. Investors should consult legal, tax, insurance and financial
          advisors. Loans are subject to lender guidelines, underwriting and borrower qualification.
        </p>
        <p className="lg:col-span-4 lg:text-right font-mono tracking-wider uppercase">
          © {new Date().getFullYear()} {CONTACT.legalName}
        </p>
      </div>
    </div>
  </footer>
  );
};
